export const EMPTY_TEXT = '-';

export const TONE_LABELS = {
    warm: '웜',
    cool: '쿨',
};

export const SEASON_LABELS = {
    spring: '봄',
    summer: '여름',
    autumn: '가을',
    winter: '겨울',
};

export const DETAIL_TONE_LABELS = {
    light: '라이트',
    bright: '브라이트',
    mute: '뮤트',
    dark: '다크',
};
